import { atom } from 'recoil';

// Thread ids currently generating a response (same-tab only — task_start/
// task_end are per-socket, not per-thread; see useThreadGenerationListener).
export const generatingThreadIdsState = atom<Set<string>>({
    key: 'GeneratingThreadIds',
    default: new Set()
});

// Thread ids that finished generating while the user was viewing a
// different thread, and haven't been opened since. Cleared the moment the
// user navigates to that thread.
export const unseenGeneratedThreadIdsState = atom<Set<string>>({
    key: 'UnseenGeneratedThreadIds',
    default: new Set()
});

export const awaitingInputThreadIdsState = atom<Set<string>>({
    key: 'AwaitingInputThreadIds',
    default: new Set()
});
